import { lazy } from 'react';

// 使用懒加载导入所有页面组件
const Index = lazy(() => import('../pages/index/index'));//首页
const ProductInfo = lazy(() => import('../pages/ProductInfo'));//产品展示页
const AboutUs = lazy(() => import('../pages/AboutUs'));//关于信维
const AIServer = lazy(() => import('../pages/AIServer'));//AI服务器主页面
const News = lazy(() => import('../pages/News'));//新闻中心
const NewsParticulars = lazy(() => import('../pages/NewsParticulars'));//新闻详情页
const EmployeeProfileDetail = lazy(() => import('../pages/AboutUs/AreaPage/EmployeeProfileDetail'));//员工风采详情页
const Nous = lazy(() => import('../pages/NousHP61'));//Nous HP61
const Solution = lazy(() => import('../pages/Solution'));//解决方案
const SolutionInfo = lazy(() => import('../pages/SolutionInfo'));//解决方案详情页
const ThreeDViewer = lazy(() => import('../pages/ThreeDViewer'));//3D模型查看器
const BookDetail = lazy(() => import('../pages/BookDetail'));//书籍详情页
const Corporate = lazy(() => import('../pages/Corporate'));//公司业务

// 英文版页面（pagesEn）
const CorporateEn = lazy(() => import('../pagesEn/Corporate'));
const IndexEn = lazy(() => import('../pagesEn/index/index'));
const AboutUsEn = lazy(() => import('../pagesEn/AboutUs'));
const SolutionEn = lazy(() => import('../pagesEn/Solution'));
const SolutionInfoEn = lazy(() => import('../pagesEn/SolutionInfo'));





// 路由配置
const routes = [
  {
    path: '/',
    key: 'index',
    element: <Index />,
    exact: true,
  },
  {
    path: '/about',
    key: 'about',
    element: <AboutUs />,
  },
   {
    path: '/news',
    key: 'news',
    element: <News />,
  },
  {
    path: '/news/:id',
    key: 'news-particulars',
    element: <NewsParticulars />,//新闻详情，,例子展示页面
  },
  {
    path: '/employee-profile/:id',
    key: 'employee-profile-detail',
    element: <EmployeeProfileDetail />,//员工风采详情页
  },
  {
    path: '/AIproduct/:id',
    key: 'products-category',
    element: <ProductInfo />,
  },
  {
    path: '/solution',
    key: 'solution',
    element: <Solution />,
  },
  {
    path: '/solution/:id',
    key: 'solution-info',
    element: <SolutionInfo />,//解决方案详情页,例子展示页面
  },
  {
    path: '/AIServer',
    key: 'AIServer',
    element: <AIServer />,
  },

  {
    path: '/Nous',
    key: 'Nous',
    element: <Nous />,
  },
  {
    path: '/AIproduct/three_d/:id',
    key: 'three-d-viewer',
    element: <ThreeDViewer />,//3D模型查看器
  },
  {
    path: '/book/detail/:id',
    key: 'book-detail',
    element: <BookDetail />,//书籍详情页
  },
  {
    path: '/services',
    key: 'services',
    element: <Corporate />,
  },
  // 英文路由 — 渲染 pagesEn
  {
    path: '/en',
    key: 'index-en',
    element: <IndexEn />,
    exact: true,
  },
  {
    path: '/en/about',
    key: 'about-en',
    element: <AboutUsEn />,
  },
  {
    path: '/en/solution',
    key: 'solution-en',
    element: <SolutionEn />,
  },
  {
    path: '/en/solution/:id',
    key: 'solution-info-en',
    element: <SolutionInfoEn />,
  },
  {
    path: '/en/news',
    key: 'news-en',
    element: <News />,
  },
  {
    path: '/en/news/:id',
    key: 'news-particulars-en',
    element: <NewsParticulars />,
  },
  {
    path: '/en/services',
    key: 'services-en',
    element: <CorporateEn />,
  },
  {
    path: '/en/AIproduct/:id',
    key: 'products-category-en',
    element: <ProductInfo />,
  },

];

export default routes;